import React, { useEffect, useState } from 'react';
import { useAuth } from '../AuthContext';
import MaintenanceScreen from './MaintenanceScreen';

/**
 * Blocks the entire app when maintenance mode is on, except for admin users.
 * Fetches the public /api/maintenance/status endpoint every 30s.
 */
export default function MaintenanceGate({ children }) {
  const { user, loading: authLoading } = useAuth();
  const [enabled, setEnabled] = useState(null); // null = not fetched yet
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    let cancelled = false;
    const fetchStatus = async () => {
      try {
        const res = await fetch(`${API_URL}/api/maintenance/status`);
        if (res.ok && !cancelled) {
          const data = await res.json();
          setEnabled(!!data.enabled);
        } else if (!cancelled) {
          setEnabled(false);
        }
      } catch {
        if (!cancelled) setEnabled(false);
      }
    };
    fetchStatus();
    const interval = setInterval(fetchStatus, 30000);
    return () => { cancelled = true; clearInterval(interval); };
  }, [API_URL]);

  // Still fetching status → render nothing to avoid flash
  if (enabled === null) return null;

  // Maintenance OFF → normal site
  if (!enabled) return children;

  // Maintenance ON — wait for auth to resolve before deciding
  if (authLoading) return null;

  // Admin bypass
  if (user?.is_admin) return children;

  return <MaintenanceScreen />;
}
